import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppToggle.css';

const WhatsAppToggle = ({ phoneNumber = '+91 7435981782', message = 'Hello!' }) => {
    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <div className="whatsapp-toggle" onClick={handleClick}>
            <FaWhatsapp />
        </div>
    );
};

export default WhatsAppToggle;
